import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OpportunityTypeFilterService } from './opportunity-type-filter.service';
import { firstValueFrom, Observable, ReplaySubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { OpportunityTypeFilterStoreService } from './opportunity-type-filter-store.service';
import { OpportunityType } from '../../sales-opportunities/interface';

@Component({
  selector: 'sales-ui-opportunity-type-filter',
  templateUrl: './opportunity-type-filter.component.html',
  styleUrls: ['./opportunity-type-filter.component.scss'],
})
export class OpportunityTypeFilterComponent {
  private readonly checkedTypes$$ = new ReplaySubject<OpportunityType[]>(1);
  readonly checkedTypes$ = this.checkedTypes$$.asObservable();
  availableTypes$: Observable<OpportunityType[]>;

  constructor(
    private readonly opportunityTypeFilterService: OpportunityTypeFilterService,
    private readonly opportunityTypeFilterStoreService: OpportunityTypeFilterStoreService,
    public dialogRef: MatDialogRef<OpportunityTypeFilterComponent>,
  ) {
    this.availableTypes$ = this.opportunityTypeFilterStoreService.availableTypes$;
    this.opportunityTypeFilterService.selectedTypes$
      .pipe(take(1))
      .subscribe((checkedTypes) => this.checkedTypes$$.next(checkedTypes || []));
  }

  public typeIdComparison(option: OpportunityType, value: OpportunityType): boolean {
    return Boolean(option) && Boolean(value) ? option.id === value.id : false;
  }

  setTypes(types: OpportunityType[]) {
    this.checkedTypes$$.next(types);
  }

  async save(): Promise<void> {
    const types = await firstValueFrom(this.checkedTypes$$);
    this.opportunityTypeFilterService.setTypeSelection(types);
    this.dialogRef.close();
  }
}
